import styled from "styled-components";
import piscina1 from '../images/piscina1.webp';
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";

const Hero = () => {
  
    
    // INIZIO PROVA HEIGHT
    const [height, setHeight] = useState(window.innerHeight - 150);
    useEffect(() => {
    const updateHeight = () => setHeight(window.innerHeight - 150);

    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
    }, []);
    // INIZIO PROVA HEIGHT



  const { t } = useTranslation();
 

  return <Wrapper>
    <div className="hero container" style={{height: `${height}px`}}>
        <h1>Il leone di mare</h1>
        <p>{t('heroSottotitolo')}</p>
    </div>
  </Wrapper>
}

export default Hero;

const Wrapper = styled.div`
    .hero {
        /* height: calc(100vh - 150px); */
        border-radius: 10px;
        background-size: cover;
        background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), url(${piscina1});
        background-position: center;
        background-repeat: no-repeat;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border: 1px solid lightgray;
        margin-bottom: 68px;
        padding: 0px 15px 75px 15px;
        h1 {
            text-align: center;
            font-size: 40px;
            color: white;
            text-shadow: 0px 2px 4px black;
        }
        p {
            text-align: center;
            font-size: 20px;
            color: white;
            text-shadow: 0px 2px 4px black;
        }
    }
`;